import { Component } from '@angular/core';
import { AuthService } from '../../../../core/services/auth.service';
import {Inject} from '@angular/core';
import { LogService } from '../../../../core/services/log.service';
import { Button } from 'primeng/button';

@Component({
  selector: 'group-detail',
  template: `
    <div *ngIf="isAllowed"><p-button icon="pi pi-search" label="Click" (onClick)="onClick()"></p-button></div>
  `
})
export class GroupDetailComponent {

  isAllowed: boolean = false;

  constructor(@Inject(AuthService) private authService: AuthService,
              @Inject(LogService) private log: LogService) { }

  ngOnInit() {
    console.log('GroupDetailComponent');
    this.isAllowed = this.authService.permissionExist('GROUPS_READ') ?? false;
  }

  onClick() {
    this.log.debug('Click');
  }

 }